import { render } from "./notification-settings.vue?vue&type=template&id=2a418dbf"
import script from "./notification-settings.vue?vue&type=script&lang=js"
export * from "./notification-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__